export default __webpack_public_path__ + "static/media/venit.572c7d6c.png";